module.exports = __webpack_public_path__ + "img/t1s.e390efac.svg";